import * as yup from 'yup';

export default yup.object().shape({
  firstName: yup.string().required('First Name is required'),
  lastName: yup.string().required('Last Name is required'),
  email: yup
    .string()
    .email('Email must be valid')
    .required('Email is required'),
  dob: yup.string().required('Date of Birth is required'),
  ssn: yup.string().required('Social Security Number is required'),
  address1: yup.string().required('Address is required'),
  address2: yup.string(),
  city: yup.string().required('City is required'),
  state: yup
    .string()
    .nullable()
    .required('State is required'),
  zip: yup.string().required('Zip is required'),
});
